import {DLCState, ProductInstallState} from '../../bridges/productBridge';
import {CatalogOffer, OfferOwnedStatus} from '../api/CatalogApi';

export enum ProductTypes {
    FETCH_PRODUCT_INSTALL_DETAILS = 'FETCH_PRODUCT_INSTALL_DETAILS',
    FETCH_PRODUCT_INSTALL_DETAILS_SUCCESS = 'FETCH_PRODUCT_INSTALL_DETAILS_SUCCESS',

    BULK_FETCH_PRODUCT_INSTALL_DETAILS = 'BULK_FETCH_PRODUCT_INSTALL_DETAILS',
    BULK_FETCH_PRODUCT_INSTALL_DETAILS_SUCCESS = 'BULK_FETCH_PRODUCT_INSTALL_DETAILS_SUCCESS',

    BULK_FETCH_PRODUCT_BUILD_ENTITLEMENTS_SUCCESS = 'BULK_FETCH_PRODUCT_BUILD_ENTITLEMENTS_SUCCESS',

    FETCH_PRODUCT_GLOBAL_AUTO_UPDATE = 'FETCH_PRODUCT_GLOBAL_AUTO_UPDATE',
    FETCH_PRODUCT_GLOBAL_AUTO_UPDATE_SUCCESS = 'FETCH_PRODUCT_GLOBAL_AUTO_UPDATE_SUCCESS',

    BULK_FETCH_PRODUCT_SETTINGS = 'BULK_FETCH_PRODUCT_SETTINGS',
    BULK_FETCH_PRODUCT_SETTINGS_SUCCESS = 'BULK_FETCH_PRODUCT_SETTINGS_SUCCESS',

    SET_PRODUCT_AUTO_UPDATE = 'SET_PRODUCT_AUTO_UPDATE',
    SET_PRODUCT_BUTTON_DISABLED = 'SET_PRODUCT_BUTTON_DISABLED',
    SET_PRODUCT_CLOUD_SAVE = 'SET_PRODUCT_CLOUD_SAVE',

    FETCH_PRODUCT_NAMESPACE_MAPPING_DATA = 'FETCH_PRODUCT_NAMESPACE_MAPPING_DATA',
    FETCH_PRODUCT_NAMESPACE_MAPPING_DATA_SUCCESS = 'FETCH_PRODUCT_NAMESPACE_MAPPING_DATA_SUCCESS',

    BULK_FETCH_PRODUCT_OFFER_OWNED_STATUS = 'BULK_FETCH_PRODUCT_OFFER_OWNED_STATUS',
    FETCH_PRODUCT_OFFER_OWNED_STATUS_SUCCESS = 'FETCH_PRODUCT_OFFER_OWNED_STATUS_SUCCESS',
    FETCH_PRODUCT_OFFER_OWNED_STATUS_FAILED = 'FETCH_PRODUCT_OFFER_OWNED_STATUS_FAILED',

    FETCH_PRODUCT_DLC_CONFIGURATION = 'FETCH_DLC_CONFIGURATION_STATES',
    FETCH_PRODUCT_DLC_CONFIGURATION_SUCCESS = 'FETCH_DLC_CONFIGURATION_STATES_SUCCESS',
    SET_PRODUCT_DLC_CONFIGURATION = 'SET_PRODUCT_DLC_CONFIGURATION',

    BULK_FETCH_PRODUCT_PREREQUISITES = 'BULK_FETCH_PRODUCT_PREREQUISITES',
    BULK_FETCH_PRODUCT_PREREQUISITES_SUCCESS = 'BULK_FETCH_PRODUCT_PREREQUISITES_SUCCESS'
}

// @depreciated
export const TYPES = ProductTypes;

export interface ProductParams {
    namespace: string;
    catalogId: string;
    appName?: string;
}

export interface ProductOfferParams {
    namespace: string;
    offerId: string;
}

export interface ProductBuildEntitlements {
    catalogId: string;
    entitledToBuild: boolean;
}

export interface ProductSettings {
    catalogId: string;
    autoUpdate: boolean;
    cloudSave: boolean;
}

export interface ProductSettingsPayload {
    settings: ProductSettings[];
}

export interface SetProductAutoUpdatePayload extends ProductParams {
    autoUpdate: boolean;
}

export interface SetProductCloudSavePayload extends ProductParams {
    cloudSave: boolean;
}

export interface ProductParamsPayload {
    productParams: ProductParams[];
}

export interface ProductOfferParamsPayload {
    offerParams: ProductOfferParams[];
}

export interface ProductInfoPayload {
    product: ProductInstallState;
}

export interface ProductsInfoPayload {
    products: ProductInstallState[];
}

export interface EntitlementsPayload {
    entitlements: ProductBuildEntitlements[];
}

export interface GlobalAutoUpdatePayload {
    globalAutoUpdate: boolean;
}

export interface SetProductButtonDisabledPayload {
    catalogId: string;
    disabled: boolean;
}

export interface ProductNamespaceMappingPayload {
    namespaceMapping: {[namespace: string]: string};
}

export interface ProductOfferOwnedStatusPayload {
    id: string;
    namespace?: string;
    ownedStatus?: OfferOwnedStatus;
    error?: string;
}

export interface FetchProductOfferOwnedStatusSuccessPayload {
    offerId: string;
    ownedStatus: OfferOwnedStatus;
}

export interface FetchProductOfferOwnedStatusFailedPayload {
    offerId: string;
    error: string;
}

export interface FetchBulkProductOfferOwnedStatusPayload {
    offers: CatalogOffer[];
}

export interface ProductDLCConfigPayload {
    config: DLCState[];
}

export interface SetProductDLCConfigPayload extends ProductParams {
    config: DLCState[];
}

export interface ProductPrerequisitePayload {
    prerequisites: any[];
}

export interface ProductAction {
    type: ProductTypes;
    payload?:
        | ProductParams
        | ProductParamsPayload
        | ProductOfferParamsPayload
        | ProductInfoPayload
        | ProductsInfoPayload
        | EntitlementsPayload
        | GlobalAutoUpdatePayload
        | SetProductButtonDisabledPayload
        | ProductNamespaceMappingPayload
        | ProductOfferOwnedStatusPayload
        | FetchBulkProductOfferOwnedStatusPayload
        | FetchProductOfferOwnedStatusSuccessPayload
        | FetchProductOfferOwnedStatusFailedPayload
        | ProductSettingsPayload
        | SetProductAutoUpdatePayload
        | SetProductCloudSavePayload
        | ProductDLCConfigPayload
        | SetProductDLCConfigPayload
        | ProductPrerequisitePayload;
}

export default {
    // @depreciated
    TYPES,

    fetchProductInstallDetails: (
        namespace: string,
        catalogId: string,
        appName: string
    ): ProductAction => ({
        type: ProductTypes.FETCH_PRODUCT_INSTALL_DETAILS,
        payload: {namespace, catalogId, appName}
    }),

    fetchProductInstallDetailsSuccess: (product: ProductInstallState): ProductAction => ({
        type: ProductTypes.FETCH_PRODUCT_INSTALL_DETAILS_SUCCESS,
        payload: {product}
    }),

    bulkFetchProductInstallDetails: (productParams: ProductParams[]): ProductAction => ({
        type: ProductTypes.BULK_FETCH_PRODUCT_INSTALL_DETAILS,
        payload: {productParams}
    }),

    bulkFetchProductInstallDetailsSuccess: (products: ProductInstallState[]): ProductAction => ({
        type: ProductTypes.BULK_FETCH_PRODUCT_INSTALL_DETAILS_SUCCESS,
        payload: {products}
    }),

    bulkFetchProductBuildEntitlementsSuccess: (
        entitlements: ProductBuildEntitlements[]
    ): ProductAction => ({
        type: ProductTypes.BULK_FETCH_PRODUCT_BUILD_ENTITLEMENTS_SUCCESS,
        payload: {entitlements}
    }),

    fetchProductGlobalAutoUpdate: (): ProductAction => ({
        type: ProductTypes.FETCH_PRODUCT_GLOBAL_AUTO_UPDATE
    }),

    fetchProductGlobalAutoUpdateSuccess: (globalAutoUpdate: boolean): ProductAction => ({
        type: ProductTypes.FETCH_PRODUCT_GLOBAL_AUTO_UPDATE_SUCCESS,
        payload: {globalAutoUpdate}
    }),

    bulkFetchProductSettings: (productParams: ProductParams[]): ProductAction => ({
        type: ProductTypes.BULK_FETCH_PRODUCT_SETTINGS,
        payload: {productParams}
    }),

    bulkFetchProductSettingsSuccess: (settings: ProductSettings[]): ProductAction => ({
        type: ProductTypes.BULK_FETCH_PRODUCT_SETTINGS_SUCCESS,
        payload: {settings}
    }),

    setProductAutoUpdate: (
        namespace: string,
        catalogId: string,
        appName: string,
        autoUpdate: boolean
    ): ProductAction => ({
        type: ProductTypes.SET_PRODUCT_AUTO_UPDATE,
        payload: {namespace, catalogId, appName, autoUpdate}
    }),

    setProductCloudSave: (
        namespace: string,
        catalogId: string,
        appName: string,
        cloudSave: boolean
    ): ProductAction => ({
        type: ProductTypes.SET_PRODUCT_CLOUD_SAVE,
        payload: {namespace, catalogId, appName, cloudSave}
    }),

    setProductButtonDisabled: (catalogId: string, disabled: boolean): ProductAction => ({
        type: ProductTypes.SET_PRODUCT_BUTTON_DISABLED,
        payload: {catalogId, disabled}
    }),

    fetchProductNamespaceMappingData: (): ProductAction => ({
        type: ProductTypes.FETCH_PRODUCT_NAMESPACE_MAPPING_DATA
    }),

    fetchProductNamespaceMappingDataSuccess: (namespaceMapping: {
        [namespace: string]: string;
    }): ProductAction => ({
        type: ProductTypes.FETCH_PRODUCT_NAMESPACE_MAPPING_DATA_SUCCESS,
        payload: {namespaceMapping}
    }),

    fetchBulkProductOfferOwnedStatus: (offers: CatalogOffer[]): ProductAction => ({
        type: TYPES.BULK_FETCH_PRODUCT_OFFER_OWNED_STATUS,
        payload: {offers}
    }),

    fetchBulkProductOfferOwnedStatusSuccess: (
        offerId: string,
        ownedStatus: OfferOwnedStatus
    ): ProductAction => ({
        type: ProductTypes.FETCH_PRODUCT_OFFER_OWNED_STATUS_SUCCESS,
        payload: {offerId, ownedStatus}
    }),

    fetchBulkProductOfferOwnedStatusFailed: (offerId: string, error: string): ProductAction => ({
        type: ProductTypes.FETCH_PRODUCT_OFFER_OWNED_STATUS_FAILED,
        payload: {offerId, error}
    }),

    fetchProductDLCConfig: (
        namespace: string,
        catalogId: string,
        appName: string
    ): ProductAction => ({
        type: ProductTypes.FETCH_PRODUCT_DLC_CONFIGURATION,
        payload: {namespace, catalogId, appName}
    }),

    fetchProductDLCConfigSuccess: (config: DLCState[]): ProductAction => ({
        type: ProductTypes.FETCH_PRODUCT_DLC_CONFIGURATION_SUCCESS,
        payload: {config}
    }),

    setProductDLCConfig: (
        namespace: string,
        catalogId: string,
        appName: string,
        config: DLCState[]
    ): ProductAction => ({
        type: ProductTypes.SET_PRODUCT_DLC_CONFIGURATION,
        payload: {namespace, catalogId, appName, config}
    }),

    bulkFetchProductPrerequisites: (offerParams: ProductOfferParams[]): ProductAction => ({
        type: ProductTypes.BULK_FETCH_PRODUCT_PREREQUISITES,
        payload: {offerParams}
    }),

    bulkFetchProductPrerequisitesSuccess: (prerequisites: any[]): ProductAction => ({
        type: ProductTypes.BULK_FETCH_PRODUCT_PREREQUISITES_SUCCESS,
        payload: {prerequisites}
    })
};
